import React, { createContext, useContext, useMemo, useState } from 'react';

const ActiveCompanyPickerContext = createContext({
  isCompanyPickerOpen: false,
  openCompanyPicker: () => {},
  closeCompanyPicker: () => {},
});

export function ActiveCompanyPickerProvider({ children }) {
  const [isCompanyPickerOpen, setIsCompanyPickerOpen] = useState(false);

  const value = useMemo(
    () => ({
      isCompanyPickerOpen,
      openCompanyPicker: () => setIsCompanyPickerOpen(true),
      closeCompanyPicker: () => setIsCompanyPickerOpen(false),
    }),
    [isCompanyPickerOpen],
  );

  return (
    <ActiveCompanyPickerContext.Provider value={value}>
      {children}
    </ActiveCompanyPickerContext.Provider>
  );
}

export function useActiveCompanyPicker() {
  return useContext(ActiveCompanyPickerContext);
}
